import { QueryClient } from '@tanstack/react-query'
import { getPrescriptions } from '../../../apis/prescription'
import { queryKeys } from './queryKeys'

/**
 * 処方箋キャッシュを全件再取得して更新する
 *
 * usePrescriptionsQuery は追加取得ロジック（差分取得）を持つため、
 * 単純な invalidateQueries では既存データの更新（報告ステータス変更等）が
 * 反映されない。
 *
 * この関数は直接 API から全件取得してキャッシュを上書きすることで、
 * データの途切れ（undefined 状態）を防ぎ、UI のちらつきや
 * スクロール位置のリセットを回避する。
 *
 * @example
 * ```tsx
 * const queryClient = useQueryClient()
 *
 * return useMutation({
 *   mutationFn: async (params) => postReport(params),
 *   onSuccess: async () => {
 *     await resetPrescriptionsCache(queryClient)
 *   },
 * })
 * ```
 *
 * @see ADR-0027 for detailed explanation of the cache invalidation issue
 */
export const resetPrescriptionsCache = async (
  queryClient: QueryClient
): Promise<void> => {
  // キャッシュを削除せず、直接 API から全件取得して上書き
  // これにより data が undefined にならず、UI のちらつきを防ぐ
  const { data } = await getPrescriptions()
  queryClient.setQueryData(queryKeys.prescriptions.list(), data)
}
